<template>
  <div>
    <div class="lyon-display-medium-24">Videos</div>
    <div v-if="loading">
      <generic-loader />
    </div>
    <div v-else-if="programVideos.length === 0">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-else class="row">
      <div
        v-for="(programVideo, index) in programVideos"
        :key="index"
        class="col-md-4 col-md-border"
      >
        <b-card
          no-body
          img-top
          class="mb-4 card-height"
        >
          <div class="mt-3">
            <div
              v-for="(video, i) in programVideo.video_file"
              :key="i"
            >
              <div v-if="video.video_file_url">
                <VideoViewSection :video="video" />
              </div>
              <div v-else class="regular-12 text-muted">
                No video available
              </div>
            </div>
          </div>
          <b-card-body>
            <b-card-title>
              <div class="text-muted regular-12">
                <span>{{ moment(programVideo.from_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
              </div>
              <router-link
                :to="{ name: 'program-schedules',
                       params: { id: $route.params.id, schedule_id: programVideo.videoable_id}}"
              >
                <span class="regular-16 typo-color-blue">{{ programVideo.title }}</span>
              </router-link>
            </b-card-title>
            <b-card-text>
              <div class="regular-14">
                {{ programVideo.name }}
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import GenericLoader from '@/components/Loaders/GenericLoader.vue'
import mixin from '@/utils/mixin.js'
import VideoViewSection from '@/components/CommonPages/VideoViewSection.vue'

export default {
  name: 'ProgramVideoTabSection',
  components: { GenericLoader, VideoViewSection },
  mixins: [mixin],
  data () {
    return {
      programVideos: [],
      loading: true
    }
  },
  mounted() {
    this.loadProgramVideos()
  },
  methods: {
    loadProgramVideos() {
      this.loading = true
      this.$http.get(process.env.VUE_APP_API_URL + `/programs/${this.$route.params.id}/program_videos`)
      .then((res) => {
        this.programVideos = res.data.program_videos
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card-height {
  min-height: 22rem !important;
  max-height: 22rem !important;
  overflow: auto;
}
</style>
